import { parseJwtPayload } from './jwt.util';
import { oauthLogger } from './logging.utils';
import { LoginCookieService } from '../services/login-cookie.service';
const OAUTH_LIB_VERSION = 'oauthlibv2';
const JWT_SESSION_KEY = 'jwtv1.1';
function getExpiredDate(issueDate, expiresIn) {
  return issueDate + (expiresIn - 15000);
}
function isValidToken(issueDate) {
  const now = Date.now();
  const result = issueDate > now;
  oauthLogger.info('Das Token wurde auf Gültigkeit geprüft: Ablaufdatum > Jetzt --> ', issueDate, ' > ', now, ' ist gleich ', result);
  return result;
}
export function clearStore() {
  sessionStorage.clear();
}
function getItem(key) {
  return sessionStorage.getItem(OAUTH_LIB_VERSION + '.' + key);
}
function setItem(key, value) {
  sessionStorage.setItem(OAUTH_LIB_VERSION + '.' + key, value);
}
function removeItem(key) {
  sessionStorage.removeItem(OAUTH_LIB_VERSION + '.' + key);
}
function getCachedToken(key, checksession = true) {
  if (getItem(key) === null) {
    oauthLogger.info(`Das Token für "${key}" ist noch nicht im Cache vorhanden.`);
    return null;
  }
  const cacheEntry = getItem(key);
  const tokenCache = JSON.parse(cacheEntry);
  // issueDate nicht älter als Login im BaLoginSession Cookie
  if (checksession && !LoginCookieService.isValidTokenSession(tokenCache.issueDate)) {
    oauthLogger.info(`Das Token für "${key}" ist älter als die aktuelle Login Session.`);
    return null;
  }
  const expiredDate = getExpiredDate(tokenCache.issueDate, tokenCache.expires_in);
  const isValid = isValidToken(expiredDate);
  if (isValid) {
    oauthLogger.info(`Das Token für "${key}" ist im Cache vorhanden und gültig.`);
    return tokenCache.access_token;
  }
  oauthLogger.warn(`Das Token für "${key}" ist im Cache vorhanden, jedoch bereits abgelaufen.`);
  return null;
}
function setToken(key, token) {
  const cachedToken = {
    access_token: token.access_token,
    issueDate: Date.now(),
    expires_in: token.expires_in * 1000,
  };
  setItem(key, JSON.stringify(cachedToken));
}
export function getCachedOagToken(clientId) {
  return getCachedToken(clientId, false);
}
export function setCachedOagToken(clientId, token) {
  setToken(clientId, token);
}
export function removeCachedOagToken(clientId) {
  removeItem(clientId);
}
export function getCachedPictureToken(picturePath) {
  return getCachedToken(picturePath);
}
export function setCachedPictureToken(picturePath, token) {
  setToken(picturePath, token);
}
export function removeCachedPicturePath(picturePath) {
  removeItem(picturePath);
}
/**
 * Gibt das vollständige JWT zurück, wenn ein gültiger Cache-Eintrag für das JWT existiert. Bei keinem gültigen Eintrag wird null zurückgegeben.
 */
export function getCachedJwt() {
  return getCachedToken(JWT_SESSION_KEY);
}
export function setCachedJwt(jwt) {
  setToken(JWT_SESSION_KEY, jwt);
}
export function removeCachedJwt() {
  removeItem(JWT_SESSION_KEY);
}
/**
 * Gibt den JWT-Payload zurück, wenn ein gültiger Cache-Eintrag für das JWT existiert. Bei keinem gültigen Eintrag wird null zurückgegeben.
 */
export function getCachedJwtPayload() {
  const jwt = getCachedJwt();
  return parseJwtPayload(jwt);
}
export const testables = {
  getExpiredDate, isValidToken, getCachedToken, getItem
};
//# sourceMappingURL=store.util.js.map
